import { Link } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import { IconGlobe, IconPin, IconMail, IconPhone, IconClock } from "./Icons";

export const Footer = () => {
  const { settings } = useSite();
  const c = settings?.contact || {};
  const logo = settings?.logo_path || "/lemur-logo.png";
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="watermark" style={{ right: "-120px", bottom: "-80px", width: "420px", height: "420px", opacity: 0.045 }} aria-hidden="true">
        <img src={logo} alt="" loading="lazy" width="420" height="420" />
      </div>
      <div className="wrap">
        <div className="foot-grid">
          <div className="foot-brand">
            <img src={logo} alt="Lemur Quality" loading="lazy" />
            <p>{settings?.footer_description}</p>
          </div>

          <div>
            <h4>Services</h4>
            <ul>
              <li><Link to="/services/livestock-quarantine-disease-prevention">Livestock Quarantine</Link></li>
              <li><Link to="/services/laboratory-testing-diagnostics">Laboratory Testing</Link></li>
              <li><Link to="/services/inspection-certification">Inspection & Certification</Link></li>
              <li><Link to="/services/training-capacity-building">Training & Capacity</Link></li>
              <li><Link to="/services">All services</Link></li>
            </ul>
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              <li><Link to="/about/who-we-are">Who We Are</Link></li>
              <li><Link to="/about/why-lemur-quality">Why Lemur Quality</Link></li>
              <li><Link to="/industries">Industries</Link></li>
              <li><Link to="/compliance">Compliance</Link></li>
              <li><Link to="/resources">Resources</Link></li>
            </ul>
          </div>

          <div>
            <h4>Contact</h4>
            <div className="fcontact">
              <div><IconPin /><span>{c.location}</span></div>
              <div><IconGlobe /><span>{c.website}</span></div>
              <div><IconMail /><a href={`mailto:${c.email}`}>{c.email}</a></div>
              <div><IconPhone /><a href={`tel:${c.phone_href || ""}`}>{c.phone}</a></div>
              <div><IconClock /><span>{c.hours}</span></div>
            </div>
          </div>
        </div>

        <div className="foot-bottom">
          <span>© {year} Lemur Quality — Compliance Consultancy Services</span>
          <div className="foot-legal">
            <Link to="/privacy-policy" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms-of-use" data-testid="footer-terms">Terms of Use</Link>
            <Link to="/cookie-policy" data-testid="footer-cookie">Cookie Policy</Link>
          </div>
          <span className="tag" data-testid="footer-tagline">{settings?.footer_tagline || "ENSURING QUALITY. ENABLING TRADE"}</span>
        </div>
      </div>
    </footer>
  );
};
